// модуль для отслеживания посещенных страниц не авторизованного юзера

app.modules.userTransitions = ((self = {}) => {
  const PATH_NAMES = {
    main: '/',
    predl: '/predl',
    reklama: '/sellers/reklama',
  };

  const VISITED_PAGES = 'visited_pages';

  function _checkPageAndSetPath() {
    const currentPath = location.pathname;
    let result = '';

    if (currentPath === PATH_NAMES.main) {
      result = 'main';
    } else if (currentPath.includes(PATH_NAMES.predl)) {
      result = 'predl';
    } else if (currentPath.includes(PATH_NAMES.reklama)) {
      result = 'reklama';
    } else {
      return;
    }

    _setPathToLocalStorage(result);
  }

  function _setPathToLocalStorage(pathname) {
    const visitedPages = localStorage.getItem(VISITED_PAGES);

    if (visitedPages?.includes(pathname)) return;

    visitedPages
      ? localStorage.setItem(VISITED_PAGES, `${visitedPages},${pathname}`)
      : localStorage.setItem(VISITED_PAGES, pathname);
  }

  function _init() {
    if (app.config.isUserDurableOnLoad) return;

    _checkPageAndSetPath();
  }

  self.load = _init;
  return self;
})(app.modules.userTransitions);
